import { render, staticRenderFns } from "./AddressLogs.vue?vue&type=template&id=b9212690"
import script from "./AddressLogs.vue?vue&type=script&setup=true&lang=js"
export * from "./AddressLogs.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports